import getEnv, { Environment } from '@/utils/environment';

const env: Environment = getEnv();

type campId = {
  [index in Environment]: string;
};

export type GoogleUrls = {
  [index in Environment]: string;
};

const campIds: campId = {
  [Environment.LOCAL]: '94B20FB00E62A732',
  [Environment.DEVMAJ]: '94B20FB00E62A732',
  [Environment.MAJSTG]: '94B20FB00E62A732',
  [Environment.PROD]: 'SR4802',
};

export const CAMP_ID = campIds[env];

const SUNRUN_URLS_BY_ENV = {
  [Environment.LOCAL]: 'https://devmaj-www.sunrundev.com',
  [Environment.DEVMAJ]: 'https://devmaj-www.sunrundev.com',
  [Environment.MAJSTG]: 'https://majstg-www.sunrun.com',
  [Environment.PROD]: 'https://www.sunrun.com',
};

export const SUNRUN_URL = SUNRUN_URLS_BY_ENV[env];

export function getBaseUrlByEnv(): string {
  return SUNRUN_URLS_BY_ENV[env];
}

export const MYSUNRUN_URL = {
  [Environment.LOCAL]: 'https://majstg-my.sunrun.com/login',
  [Environment.DEVMAJ]: 'https://majstg-my.sunrun.com/login',
  [Environment.MAJSTG]: 'https://majstg-my.sunrun.com/login',
  [Environment.PROD]: 'https://my.sunrun.com/login',
};

export function getLoginUrlByEnv(): string {
  return MYSUNRUN_URL[env];
}

export const GATEWAY_BASE: { dev: string; stageOrProd: string } = {
  dev: 'https://gateway.sunrundev.com',
  stageOrProd: 'https://gateway.sunrun.com',
};

export const PXE_BACKEND_URL = {
  [Environment.LOCAL]: `${GATEWAY_BASE.dev}/devmaj-pxe-backend`,
  [Environment.DEVMAJ]: `${GATEWAY_BASE.dev}/devmaj-pxe-backend`,
  [Environment.MAJSTG]: `${GATEWAY_BASE.stageOrProd}/majstg-pxe-backend`,
  [Environment.PROD]: `${GATEWAY_BASE.stageOrProd}/pxe-backend`,
};

export const PORTAL_AUTH_BASE_URL = {
  local: `${GATEWAY_BASE.stageOrProd}/majstg-portal-auth`,
  devmaj: `${GATEWAY_BASE.stageOrProd}/majstg-portal-auth`,
  majstg: `${GATEWAY_BASE.stageOrProd}/majstg-portal-auth`,
  prd: `${GATEWAY_BASE.stageOrProd}/portal-auth`,
};

export const RETROFIT_LEAD_URL = `${PXE_BACKEND_URL[env]}/retrofit-lead`;

export const RETROFIT_PROPOSAL_URL = `${PXE_BACKEND_URL[env]}/retrofit-proposal`;

export const BATTERY_PRODUCTS_URL = `${PXE_BACKEND_URL[env]}/battery-products`;
